import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hui from 'hui';
import api from 'axios';
import { memoize } from 'lodash';

const CategoryAutocomplete = hui.CategoryAutocomplete;
const fetchSuggestions = memoize(query => api.get('/api/directory/categories', { params: { query } }));

export default class CategorySearch extends Component {
  static propTypes = { // eslint-disable-line
    classPrefix: PropTypes.string,
    placeholder: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onSelect: PropTypes.func
  };

  static defaultProps = { // eslint-disable-line 
    classPrefix: 'hero__directory-category',
    placeholder: 'E.g. Plumber, Electrician, Carpenter'
  };

  state = { // eslint-disable-line
    category: {}
  };

  onSelect = (category) => { // eslint-disable-line
    if (this.props.onSelect) this.props.onSelect(category);
    this.setState({ category });
  };

  render() {
    const { onFocus, onBlur } = this.props;
    const { category } = this.state;
    return (
      <CategoryAutocomplete
        classPrefix={this.props.classPrefix}
        value={category.name}
        data-placeholder={this.props.placeholder}
        placeholder={this.props.placeholder}
        onSelectCategory={this.onSelect}
        name="category"
        fetchSuggestions={fetchSuggestions}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./homepage/scripts/components/directory-category-autocomplete.js